import {
    Component,
    OnInit,
    HostBinding,
    Input
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { BehaviorSubject, Observable } from 'rxjs';

@Component({
    selector: 'scw-access-dice',
    templateUrl: './access-dice.component.pug',
    styleUrls: ['./access-dice.component.less'],
    providers: []
})
export class SCWAccessDiceComponent implements OnInit {
    _currentSbj: BehaviorSubject<number> = new BehaviorSubject(0);
    current$: Observable<number> = this._currentSbj.asObservable();

    _hint: SafeHtml = '';
    @Input() set hint(hint: SafeHtml) {
        this._hint = this._sanitizer.bypassSecurityTrustHtml(hint as string);
    }
    get hint(): SafeHtml {
        return this._hint;
    }

    @Input() unlimited: boolean = false;
    @Input() accessCost: number = 5;
    @Input() ready: boolean = false;

    @Input() granted: boolean = false;
    @Input() set current(current: number) {
        this._currentSbj.next(current || 0);
    }

    get current() {
        return this._currentSbj.getValue();
    }

    get displayCurrent(): number {
        return Math.min(this.current, this.accessCost);
    }

    @HostBinding('class') get _class() {
        const classes = [];

        if (this.unlimited) {
            classes.push(`--season-access-cost-5`);
            classes.push(`--access-5`);
        } else {
            classes.push(`--season-access-cost-${ this.accessCost }`);
            classes.push(`--access-${ Math.min(this.current, this.accessCost) }`);
        }
        this.granted && classes.push('--access-granted');

        return classes.join(' ');
    }

    constructor(
        private _sanitizer: DomSanitizer,
    ) {
    }

    ngOnInit() {
    }
}
